export enum ChallengeArchived {
  PUBLISHED = 0,
  UNPUBLISHED = 1,
  ARCHIVED = 2
}
